import { TileReader } from "./carto-properties-tile.js";
import { parsePbf } from "./tile-loader-utils.js";
const CartoPropertiesTileLoader = {
    name: 'CARTO Properties Tile',
    version: '1',
    id: 'cartoPropertiesTile',
    module: 'carto',
    extensions: ['pbf'],
    mimeTypes: ['application/vnd.carto-properties-tile'],
    category: 'geometry',
    worker: false,
    parse: async (arrayBuffer, options) => parseCartoPropertiesTile(arrayBuffer, options),
    parseSync: parseCartoPropertiesTile,
    options: {}
};
function parseCartoPropertiesTile(arrayBuffer, options) {
    if (!arrayBuffer)
        return null;
    return parsePbf(arrayBuffer, TileReader);
}
export default CartoPropertiesTileLoader;
